// src/common/components/confirmModalContent/ConfirmModalContent.tsx
import React from 'react'
import classes from './ConfirmModalContent.module.scss'
import Button from '../button/Button'

type Props = {
  title: string
  description?: string
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  onCancel: () => void
  loading?: boolean
}

export const ConfirmModalContent = ({
  title,
  description,
  confirmText = 'Подтвердить',
  cancelText = 'Отмена',
  onConfirm,
  onCancel,
  loading = false,
}: Props) => {
  return (
    <div className={classes.container}>
      <div className={classes.title}>{title}</div>
      {description && <div className={classes.description}>{description}</div>}

      <div className={classes.actions}>
        <Button
          title={confirmText}
          onClick={onConfirm}
          variant="primary"
          loading={loading}
          fullWidth
        />
        <Button
          title={cancelText}
          onClick={onCancel}
          variant="outline"
          size="small"
        />
      </div>
    </div>
  )
}